/**
 * Cruise insurance selection
 * Controls the insurance widget that comes integrated in the payment page
 * This holds both scenarios for inline (allianz Interval) and the common UI
 */

// Model to hold all properties to initialize the view
let insuranceModel = Backbone.Model.extend({
  defaults: {
    smokers: 0
  }
});

var InsuranceSelectionView = Backbone.View.extend({
  events: {
    "click [data-insurance-quote-trigger]": "fetchQuote",
    "click [data-insurance-selector]": "toggleApplyUpdate",
    "click [data-insurance-apply-trigger]": "updatePricing",
    "click [data-insurance-option-group-selector]": "activateGroup",
    "click [data-insurance-selector-decline]": "deactivateInsurance",
    "collapserView:closed [data-collapser-insurance-type]": "toggleApplyUpdate",
    "change [data-insurance-quote-smoker]": "recountSmokers",
    "keyup [data-insurance-quote-field]": "toggleDisable",
    "click [data-insurance-quote-field-check]": "toggleDisable"
  },

  fetchQuote: function() {
    var fields = this.$(
      "[data-insurance-quote-field]:not(':disabled'), [data-insurance-quote-field-check]:checked"
    );

    let searchRateTrigger = this.$("[data-insurance-quote-trigger]");

    searchRateTrigger.attr("disabled", true);

    // Get element were content will be printed
    const loader = this.el.querySelector(
      "[data-insurance-quote-content-loader]"
    );

    this.$("[data-insurance-quote-content-loader]").addClass("is-loading");

    // fetch content from vendor
    fetch(
      this.settings.urls.quote + ($.param(fields) ? "?" + $.param(fields) : ""),
      {
        credentials: "same-origin"
      }
    )
      .then(response => {
        return response.text();
      })
      .then(data => {
        this.$("[data-insurance-quote-content-loader]").removeClass(
          "is-loading"
        );
        loader.innerHTML = data;

        // if the insurance type is inline, we do all the mods that are
        // required to display Allianz as expected
        if (this.settings.insuranceType === "inline") {
          this.cloneLabels();
        }

        this.settings.isInitialized = true;
        $(loader).loadComponents();
        $(loader).loadModules();
        // this.$("[data-insurance-quote-trigger]").removeAttr("disabled");
        const form = $('[data-component="form"]').component();
        form.reflow();
        searchRateTrigger.attr("disabled", true);
      })
      .catch(error => {
        // this.$("[data-insurance-quote-trigger]").removeAttr("disabled");
        this.$("[data-insurance-quote-content-loader]").removeClass(
          "is-loading"
        );
        // report request failed
        loader.innerHTML = "Unable to retrieve requested data.";
      });
  },

  toggleApplyUpdate: function(e) {
    let trigger = this.$("[data-insurance-apply-trigger]");

    let currentSelection = $(this.insuranceIdLabel + ":checked");

    let currentSelectionValue =
      !currentSelection.is("[disabled]") && currentSelection.length
        ? currentSelection.val()
        : "decline";

    let validateSection =
      e.type !== "collapserView:closed" && !this.settings.hasInitSelection;

    if (this.settings.hasInitSelection !== currentSelectionValue) {
      trigger.parent().removeClass("is-hidden");
      trigger.removeAttr("disabled");
      validateSection = true;
    } else {
      trigger.parent().addClass("is-hidden");
      trigger.attr("disabled", true);

      validateSection = false;
    }

    $('[data-form-section-validate="' + this.settings.thread + '"]').attr(
      "disabled",
      validateSection
    );
  },

  updatePricing: function() {
    var data = $('[data-component="form"]').serializeJSON();

    var sendData = {
      insurance: data.insurance
    };

    Backbone.Events.trigger("loadingSplashOn");

    window.location = this.settings.urls.pricing + "?" + $.param(sendData);
  },

  activateGroup: function(e) {
    this.groupSelector = $(e.currentTarget).data(
      "insurance-option-group-selector"
    );
    this.$(
      "[data-insurance-selector-group=" + this.groupSelector + "]"
    ).trigger("click");
  },

  // this is used to grab the labels from Allianz
  // response and add them to our global labels
  cloneLabels: function(e) {
    let currentYesLabel =
      this.$(
        "[data-insurance-option='insurance-product" +
          this.settings.thread +
          "']"
      ) || false;
    let currentNoLabel = this.declineInsurance || false;
    let yesLabel = this.$("[for='WASCInsuranceOfferOption0']").html() || false;
    let noLabel = this.$("[for='WASCInsuranceOfferOption1']").html() || false;

    if (yesLabel) {
      currentYesLabel.html(yesLabel);
    }
    if (noLabel) {
      currentNoLabel.html(noLabel);
    }
    this.settings.isInitialized = true;
  },

  // deactivating all insurance when hitting on decline
  deactivateInsurance: function(e) {
    this.groupSelector = $(e.currentTarget).data(
      "insurance-option-group-selector"
    );

    this.$("[data-insurance-selector]")
      .not("[data-insurance-selector-decline]")
      .prop("checked", false)
      .attr("required", false);

    this.$("[data-insurance-apply-trigger]").attr("disabled", true);

    $('[data-form-section-validate="' + this.settings.thread + '"]').attr(
      "disabled",
      false
    );

    this.toggleApplyUpdate(true);
  },

  // updating smoker count
  recountSmokers: function() {
    let counter = this.smokerWrapper.find(
      "[data-insurance-quote-smoker]:checked"
    ).length;

    this.insuranceModel.set("smokers", counter);
  },

  // picking method to retrieve or modify dataSet
  fetchMethod: function() {
    // if PostalCode is required, autoFetch thirdparty insurance when is selected
    let isThirdParty =
      this.settings.autoFetch &&
      this.$("[data-insurance-selector]:checked").val() === "thirdparty";

    if (
      (this.settings.autoFetch || isThirdParty) &&
      !this.settings.isInitialized
    ) {
      // fetching data to render
      this.fetchQuote();
    } else {
      // Insurance modify button to be enabled for search
      // this.$("[data-insurance-quote-trigger]").removeAttr("disabled");

      // if its inline do the inline method to hold Allianz modifications
      if (this.settings.insuranceType === "inline") {
        this.cloneLabels();
      }
    }
  },

  toggleDisable: function(e) {
    let currentTarget = $(e.currentTarget);
    let currentTargetValue =
      currentTarget.val() || currentTarget.find("select").val();

    currentTarget.is("[data-insurance-quote-field-check]") ||
    (isNaN(parseInt(currentTargetValue)) && currentTargetValue.length)
      ? this.$("[data-insurance-quote-trigger]").attr("disabled", false)
      : this.$("[data-insurance-quote-trigger]").attr("disabled", true);
  },

  initialize: function() {
    // setting the model
    this.insuranceModel = new insuranceModel();

    // checking if the smoker wrapper is present on the page
    this.smokerWrapper = this.$("[data-insurance-smoker-wrapper]") || false;

    // sending the template the initial data + smokers data
    this.$el.loadTemplates({ data: this.insuranceModel });
    this.insuranceModel.on("change", this.$el.renderItems.bind(this));

    this.settings = {
      thread: null,
      isInitialized: false,
      autoFetch: false,
      autoFetchThirdParty: false,
      hasInitSelection: "decline"
    };

    if (this.$el.data("settings")) {
      this.settings = this.settings = $.extend(
        true,
        this.settings,
        this.$el.data("settings")
      );
    }

    this.declineInsurance = this.$(
      "[data-insurance-option='data-insurance-decline" +
        this.settings.thread +
        "']"
    );

    this.insuranceIdLabel =
      "[name='insurance" + this.settings.threadInput + "[id]']";

    if (this.$("[data-country-state-select]").length) {
      this.$("[data-country-state-select]").on("states-loading", () => {
        // while loading result set, disable modify search button
        this.$("[data-insurance-quote-trigger]").attr("disabled", true);
      });

      this.$("[data-country-state-select]").on("states-updated", e => {
        // when states are loaded enable modify search
        this.toggleDisable(e);

        this.fetchMethod();
      });
    }

    this.fetchMethod();
  }
});

module.exports = InsuranceSelectionView;
